import React from 'react';
import withStyles from 'isomorphic-style-loader/withStyles';
import { flowRight as compose } from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import EditProfileInfo from '../../../components/siteadmin/EditProfileInfo/EditProfileInfo';
import Loader from '../../../components/Loader/Loader';
import { decode } from '../../../helpers/queryEncryption';
import { censorEmail, censorPhone } from '../../../helpers/secureEmail';
import { demoRestrictionEncode } from '../../../helpers/DemoRestriction/demoRestriction';
import showUserProfile from './showUserProfile.graphql';
import { withQuery } from '../../../hoc/withGraphql';

import s from './EditProfile.css';
import NotFound from '../../notFound/NotFound';

class EditProfile extends React.Component {
    static propTypes = {
        profileId: PropTypes.number.isRequired,
        showUserProfile: PropTypes.object,
    };

    constructor(props) {
        super(props);
        this.state = {
            isRestrict: false,
        };
    }

    async componentDidMount() {
        const { demoRestrictionEncode } = this.props;
        const isRestrict = await demoRestrictionEncode();
        this.setState({ isRestrict });
    }

    render() {
        const { userData, profileId } = this.props;
        const { isRestrict } = this.state;

        let loading = userData?.loading, initialValues = {};

        if (loading) {
            return (
                <Loader type={"text"} />
            )
        }

        if (!loading && !userData?.showUserProfile?.firstName) {
            return (
                <NotFound />
            )
        }

        if (userData?.showUserProfile) {
            initialValues = {
                ...userData?.showUserProfile,
                phoneNumber: !isRestrict ? decode(userData?.showUserProfile?.phoneNumber) : censorPhone(decode(userData?.showUserProfile?.phoneNumber)),
                profileBanStatus: {
                    email: !isRestrict ? decode(userData?.showUserProfile?.profileBanStatus?.email) : censorEmail(decode(userData?.showUserProfile?.profileBanStatus?.email))
                },
                isRestrict
            };
        }

        return (
            <>
                <EditProfileInfo
                    initialValues={initialValues}
                    profileId={profileId}
                    userId={userData?.showUserProfile?.userId}
                />
            </>
        )
    }
}

const mapState = state => ({});

const mapDispatch = {
    demoRestrictionEncode
};

export default compose(withStyles(s),
    connect(mapState, mapDispatch),
    withQuery(showUserProfile, {
        name: 'userData',
        options: (props) => ({
            variables: {
                profileId: props?.profileId
            },
            ssr: false,
            fetchPolicy: 'network-only'
        })
    }),
)(EditProfile);
